import React from 'react';
import QuerySampleCard from '../components/QuerySampleCard';
import QueryHelpPageLayout from '../QueryHelpPageLayout';
import {QUERY_HELP_PAGE_INTROS} from '../content/pages';
import {SALES_PAGE_INTRO, SALES_SAMPLE_GROUPS} from '../content/salesExamples';

const SalesExamplesPage = React.memo(() => (
    <QueryHelpPageLayout
        title="Sales examples"
        intro={QUERY_HELP_PAGE_INTROS.sales}
    >
        <section className="query-help-modal__tip-section">
            <h4 className="query-help-modal__section-title">{SALES_PAGE_INTRO.title}</h4>
            <p className="query-help-modal__section-intro">{SALES_PAGE_INTRO.body}</p>
        </section>

        {SALES_SAMPLE_GROUPS.map((group) => (
            <section key={group.id} className="query-help-modal__sample-group">
                <h4 className="query-help-modal__section-title">{group.title}</h4>
                <div className="query-help-modal__sample-list">
                    {group.items.map((item) => (
                        <QuerySampleCard key={item.id} item={item} />
                    ))}
                </div>
            </section>
        ))}
    </QueryHelpPageLayout>
));

export default SalesExamplesPage;
